import React, { useCallback, useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Box
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { addSnackbar } from "../../redux/snackbarSlice";
import { httpCallables } from "../../firebase";
const PERSONAS = ["DEVIOUS", "HACKER", "NORMAL", "OVERACHIEVER", "DISENGAGED"];

export const StudentSimulation = ({
  onComment,
  questionId,
  chatLength,
  isChatLoading
}) => {
  const dispatch = useDispatch();
  const [selectedPersona, setSelectedPersona] = useState("");
  const courseId = useSelector(
    (state) => state.user.userProfile?.selectedCourseId
  );
  const textId = useSelector((state) => Number(state.texts.selectedTextId));

  const submissionId = useSelector(
    (state) => Number(state.router.location.query?.submission_id) || null
  );
  const userUid = useSelector((state) => state.firebase.auth.uid);
  const [isLoading, setIsLoading] = useState(false);

  const generateComment = useCallback(
    (funcParams, handler) => {
      if (funcParams?.func_params?.persona && handler) {
        setIsLoading(true);
        httpCallables.ementoringInteraction2(funcParams).then(({ data }) => {
          const { success } = data;
          setIsLoading(false);
          if (success) {
            const { payload } = data;
            const resposne = JSON.parse(payload);
            handler(resposne.text);
          } else {
            const { error } = data;
            dispatch(
              addSnackbar({
                message: `Error fetching ementoringInteraction. ${error.message}`
              })
            );
          }
        });
      }
    },
    [dispatch, setIsLoading]
  );

  useEffect(() => {
    if (selectedPersona && chatLength > 0 && !isChatLoading) {
      const data = {
        func_params: {
          botType: "studentEmulator",
          questionId,
          submissionId,
          userUid,
          textId,
          persona: selectedPersona,
          courseId
        },
        func_name: "mentorInteraction"
      };
      generateComment(data, onComment);
    }
  }, [selectedPersona, chatLength, isChatLoading, generateComment]);

  const handleChange = (e) => {
    setSelectedPersona(e.target.value);
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="persona-label">Student Persona</InputLabel>
      <Select
        labelId="persona-label"
        id="persona-select"
        value={selectedPersona}
        label="Persona"
        onChange={handleChange}
        endAdornment={
          isLoading ? (
            <Box
              sx={{
                position: "absolute",
                right: 32,
                display: "flex",
                alignItems: "center"
              }}>
              <CircularProgress size={20} />
            </Box>
          ) : null
        }>
        {PERSONAS.map((persona, index) => (
          <MenuItem key={index} value={persona}>
            {persona}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
